import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Signin from "./components/Signin";
import Home from "./views/Home";
import Error from "./components/Error";
import Profile from "./views/Profile";
import {AuthorizationExample} from "./views/AuthorizationExample";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";

// styles
import "./App.css";

const App = () => {
  const { isLoading, error, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Router history={history}>
      <div id="app" className="d-flex flex-column h-100">
        <NavBar />
        <Error error={error}/>
        <Container className="flex-grow-1 mt-5">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/profile" component={Profile} />
            <Route path="/login" component={Login}/>
            <Route path="/signin" component={Signin}/>
            <Route path="/authorization" component={AuthorizationExample} />
          </Switch>
        </Container>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
